export default {
    formInit() {
        return {
            firstName: "",
            lastName: "",
            email: "",
            idNumber: "",
            mobile: "",
            designation: ""
        };
    }
};
